
(()=>{
 const root=document;
 const nav=root.querySelector('.sm-nav');
 const navigation=root.querySelector('#sm-navigation');
 const menuToggle=root.querySelector('.sm-menu-toggle');
 const groups=Array.from(nav?.querySelectorAll('.sm-nav-group') || []);
 const mobile=window.matchMedia('(max-width: 1199px)');
 if (nav) {
 nav.setAttribute('data-enhanced','');
 function closeGroups(){groups.forEach(group=>{group.open=false;});}
 function setMobileMenu(open){navigation.hidden=mobile.matches&&!open;menuToggle.setAttribute('aria-expanded',String(open));menuToggle.querySelector('span').textContent=open?'−':'＋';if(!open)closeGroups();}
 setMobileMenu(false);
 menuToggle.addEventListener('click',()=>setMobileMenu(menuToggle.getAttribute('aria-expanded')!=='true'));
 root.querySelectorAll('[data-open-menu]').forEach(button=>button.addEventListener('click',event=>{
   event.stopPropagation();
   const group=root.querySelector('#'+button.dataset.openMenu);
   setMobileMenu(true);closeGroups();group.open=true;
   group.querySelector('summary').focus({preventScroll:true});
   root.querySelector('.sm-site-header').scrollIntoView({block:'start'});
 }));
 groups.forEach(group=>{
   group.addEventListener('toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false;});});
   group.querySelector('summary').addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();closeGroups();group.open=true;const first=group.querySelector('a');if(first)first.focus();}});
 });
 nav.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const open=groups.find(group=>group.open);if(open){open.open=false;open.querySelector('summary').focus();}else if(mobile.matches&&!navigation.hidden){setMobileMenu(false);menuToggle.focus();}event.preventDefault();});
 document.addEventListener('click',event=>{if(!nav.contains(event.target)){closeGroups();if(mobile.matches)setMobileMenu(false);}});
 nav.addEventListener('focusout',()=>{setTimeout(()=>{if(!nav.contains(document.activeElement)){closeGroups();if(mobile.matches)setMobileMenu(false);}},0);});
 nav.addEventListener('click',event=>{if(event.target.closest('a')){closeGroups();if(mobile.matches)setMobileMenu(false);}});
 mobile.addEventListener('change',()=>{const focused=nav.contains(document.activeElement);setMobileMenu(false);if(focused){if(mobile.matches)menuToggle.focus();else navigation.querySelector('a').focus();}});

 }
 const holiday = root.querySelector('.holiday-panel');
 if (!holiday) return;
 const tabletop = [...holiday.querySelectorAll('[name="holiday-item"]')];
 function showHolidaySelection() {
   const chosen = tabletop.filter(input => input.checked);
   for (const input of tabletop) input.disabled = chosen.length >= 8 && !input.checked;
   const scene = holiday.querySelector('[name="holiday-template"]:checked').value;
   const campaignLink = holiday.querySelector('.sm-cta');
   const destination = new URL(campaignLink.href);
   const sceneKey = holiday.querySelector('[name="holiday-template"]:checked').dataset.key;
   destination.searchParams.set('scene', sceneKey);
   destination.searchParams.set('table', chosen.map(input => input.dataset.key).join(','));
   campaignLink.href = destination.href;
   const items = chosen.map(input => input.value).join(', ');
   holiday.querySelector('.holiday-selection').textContent = scene + ' · ' + chosen.length + ' of 8 selected' + (items ? ' · ' + items : '');
 }
 holiday.addEventListener('change', showHolidaySelection);
 showHolidaySelection();
})();
